import { LogoPropsType } from './logoTypes';

export default function MicrosoftLogo({ monochrome = false, className }: LogoPropsType) {
  return (
    <svg viewBox="0 0 1639 350" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g>
        <path
          d="M0,0h166.5c0,55.5,0,111,0,166.5c-55.5,0-111,0-166.5,0V0L0,0z"
          fill={monochrome ? 'currentColor' : '#F25022'}
        />
        <path
          d="M183.5,0H350c0,55.5,0,111,0,166.5c-55.5,0-111,0-166.5,0C183.5,111,183.5,55.5,183.5,0L183.5,0z"
          fill={monochrome ? 'currentColor' : '#80BA01'}
        />
        <path
          d="M1501.4,63.4c15.4-10,35.2-10.9,52.5-6.2c0.1,10.3,0,20.6,0.1,30.9c-8.2-3.6-17.9-6-26.5-2.4
				c-6.9,2.7-10.9,9.8-12,16.8c-1.3,8.9-0.4,18-0.7,27c17.6,0,35.1,0,52.7,0c0.1-11.4-0.1-22.8,0.2-34.2
				c11.9-3.4,23.8-7.2,35.6-10.8c0.1,15-0.1,30,0.1,45.1c11.9-0.2,23.8,0,35.6-0.1v29.2c-11.9-0.5-23.8-0.1-35.8-0.2
				c0.1,16.8,0,33.6,0,50.4c0.2,9.3-0.5,18.7,0.6,27.9c0.7,5.5,2.6,11.5,7.8,14.4c8.6,4.8,19.5,2.7,27.4-2.6v29.5
				c-10.3,4.5-21.8,5.8-32.9,5c-10.6-0.8-21.5-4.6-28.4-13c-8-9.5-10-22.3-10.2-34.4c-0.1-25.8,0-51.6,0-77.4c-17.6,0-35.1,0-52.7,0
				c0,40.5,0,81,0,121.5c-12,0-24,0-36,0c0-40.5-0.1-81,0-121.4c-8.3-0.2-16.7,0-25.1-0.1c0-9.6,0.1-19.2,0-28.9
				c8.3-0.2,16.6-0.1,25-0.1c0.6-12.8-1.3-25.9,2.5-38.4C1484.4,79.9,1491.6,69.8,1501.4,63.4L1501.4,63.4z M730.5,65.5
				c-10,1.1-18.5,10.2-18.3,20.4c-0.4,9.7,7.4,18.4,16.7,20.1c9,2,19.4-1.8,24-10c4.2-7.3,3.1-17.2-2.5-23.4
				C745.6,66.9,737.7,64.4,730.5,65.5L730.5,65.5z M454.5,70c0,70,0,140,0,210c11.4,0,22.9,0,34.3,0c0-31.3,0-62.7,0-94
				c0.1-22.6-0.2-45.3,0.2-67.9c0.6,1,1.2,2.1,1.8,3.2c21.4,52.9,42.6,105.9,64,158.8c8.6-0.1,17.3,0.1,25.9-0.2
				c20.7-52.9,41.9-105.6,62.7-158.5c0.5-1.2,1.2-2.3,1.9-3.4c0.2,2.3,0.2,4.6,0.2,7c-0.1,51.7,0.1,103.3-0.1,155
				c12.1,0.2,24.2,0,36.3,0.1c0-70,0-140,0-210c-16.8,0-33.6-0.2-50.4,0.1c-20.8,51.8-42.1,103.4-63.1,155.1
				c-4.4-10.3-8.3-20.7-12.4-31.1c-16.3-41.4-32.7-82.7-49-124.1C489.4,70,472,70,454.5,70L454.5,70z M829.6,129.3
				c-16,4.6-30.6,14.4-40,28.2c-11.2,16.2-15.1,36.5-14.2,55.9c0.9,18.7,8.2,37.3,21.8,50.4c12.5,12.1,29.7,18.6,46.9,19.6
				c16.9,0.8,34.5-1.4,49.2-10.2c-0.1-10.9,0-21.7-0.1-32.6c-9.5,6.9-20.6,11.9-32.3,13.3c-11.9,0.9-24.6-2-33.7-10
				c-8.7-7.5-13.4-18.7-14.5-29.9c-1.5-14.4,0.5-29.9,9.5-41.7c7-9.5,18.2-15.6,29.9-16.6c14.8-1.9,29.5,3.8,41.1,12.6
				c0.1-11.5-0.1-23,0.1-34.4c-3.2-1.9-6.7-3.3-10.3-4.3C865.7,124.6,847,124.4,829.6,129.3L829.6,129.3z M1222.9,127.1
				c-14.1,2.5-27.9,9.8-35.8,22c-7,10.5-7.9,23.9-5,35.9c1.9,8.1,6.9,15.3,13.5,20.4c9.3,7.1,20.5,11.1,31.1,15.9
				c5.7,2.7,11.6,5.4,15.7,10.3c4.4,6.4,3,16.8-4.3,20.5c-7.7,3.7-16.6,3.6-24.9,2.3c-11.8-2-23-7.1-32.7-14.1
				c-0.1,11.6,0,23.2-0.1,34.8c11.5,5.1,24.1,7.6,36.6,8.4c17.6,0.7,36.8-2.8,50.1-15.2c13.9-12.3,17.3-34.1,9.4-50.7
				c-4.2-8.8-12.3-14.9-20.6-19.6c-10.6-6.1-22.8-9-33-15.9c-6-3.8-7.7-12.1-5.2-18.4c3.1-6.4,10.5-9.2,17.2-9.5
				c13.4-0.5,26.8,3.6,37.8,11.2c0-11,0-22.1,0-33.1C1257,126.3,1239.6,124.1,1222.9,127.1L1222.9,127.1z M973.8,131.8
				c-9,5.1-14.8,14.2-18.6,23.6c0-8.6,0-17.2,0-25.8c-11.9-0.1-23.7-0.1-35.5,0c0.1,50.1,0,100.3,0,150.4c11.8,0,23.7,0,35.5,0
				c0-24,0-48,0-72c-0.3-10.4,0.6-21.2,5.1-30.7c4.2-9,12.3-16.9,22.5-18c8.4-0.8,17.2,1.1,24.3,5.7c0-12,0-24,0-36
				C996.4,125.3,983.8,125.8,973.8,131.8L973.8,131.8z M715.5,129.5c0,50.2,0,100.3,0,150.5c11.9,0,23.8,0,35.7,0
				c0-50.1-0.1-100.3,0.1-150.4C739.4,129.4,727.4,129.5,715.5,129.5L715.5,129.5z M1163.7,212.1c-1.1,15.7-6,31.4-15.8,43.8
				c-10,13.2-25.2,22.2-41.3,25.5c-13.8,2.9-28.3,2.9-42.2,0c-16.6-3.5-31.9-13.1-41.6-27.1c-11.4-16.2-14.6-36.8-13.2-56.2
				c1-16.5,6.1-33.1,16.6-46c11.5-14.5,29.2-23,47.3-25.3c17.3-2.2,35.5-1.2,51.5,6.1c13.9,6.3,25.2,17.9,31.5,31.8
				C1163.2,179.4,1164.8,196,1163.7,212.1z M1126.8,196.9c-0.9-11.3-4.1-23.2-12.4-31.4c-7.8-7.9-19.3-10.9-30.1-10.2
				c-8.6,0.5-17.3,3.4-23.7,9.4c-8.8,8-12.8,19.8-13.9,31.4c-1.2,12.7-0.3,26.1,5.5,37.7c4.5,9,12.8,16,22.6,18.6
				c9.6,2.5,20.1,2.3,29.4-1.3c7.9-3.1,14.2-9.6,17.7-17.4C1127,222.2,1127.5,209.3,1126.8,196.9z M1450.5,204.9
				c0,18.2-4.9,36.8-16.3,51.3c-10.7,14-27,23-44.3,25.9c-16.9,2.7-34.7,2-50.7-4.3c-16.2-6.4-29.7-19.4-36.6-35.5
				c-7.1-16.4-7.9-34.8-5.7-52.3c2.3-17.5,10.2-34.6,23.8-46.2c11.1-9.7,25.3-15.2,39.8-17.1c18-2.2,37-1,53.4,7.3
				c14.3,7.2,25.4,20.1,30.9,35C1449.3,180.4,1450.8,192.8,1450.5,204.9z M1412.1,187.8c-1.8-9-5.8-18-13-24
				c-7.8-6.9-18.7-9.2-28.8-8.5c-10,0.6-19.8,4.8-26.3,12.6c-7.1,8.3-10.1,19.3-10.9,30c-0.8,11,0,22.5,4.3,32.8
				c3.5,8.7,10.3,16.2,19,19.9c8.1,3.5,17.1,4.1,25.8,2.8c8-1.2,15.8-5,21-11.3c5.2-6.3,7.9-14.2,9.3-22.1
				C1414.2,209.4,1414.2,198.4,1412.1,187.8z"
          fill={monochrome ? 'currentColor' : '#777777'}
        />
        <path
          d="M0,183.5c55.5,0,111,0,166.5,0c0,55.5,0,111,0,166.5H0V183.5L0,183.5z"
          fill={monochrome ? 'currentColor' : '#02A4EF'}
        />
        <path
          d="M183.5,183.5c55.5,0,111,0,166.5,0c0,55.5,0,111,0,166.5H183.5C183.5,294.5,183.5,239,183.5,183.5
				L183.5,183.5z"
          fill={monochrome ? 'currentColor' : '#FFB902'}
        />
      </g>
    </svg>
  );
}
